import {Loading, MessageBox, Message, Notification} from "element-ui"

const state = {
    totalCount: 0,
    notifications: [],
    dashboardNotifications: [],
    newNotificationStatus: false,
    listener: false
}

const getters = {
    newNotificationStatus: state => {
        return state.newNotificationStatus
    },
    notifications: state => {
        return state.notifications
    },
    dashboardNotifications: state => {
        return state.dashboardNotifications
    },
    totalCount: state => {
        return state.totalCount
    }
}

const mutations = {
    setListener(state, listener) {
        state.listener = listener
    },
    setNewNotification: state => {
        return state.newNotification
    },
    setNotifications(state, notifications) {
        state.notifications = notifications
    },
    setDashboardNotifications(state, notifications) {
        state.dashboardNotifications = notifications
    },
    setNewNotificationStatus(state, status) {
        state.newNotificationStatus = status
    },
    setTotalCount(state, totalCount) {
        state.totalCount = totalCount
    }
}

const actions = {
    fetchNotitications(context) {
        Ambition.Request.call({
            url: "/api/notifications"
        }).then(e => {
            const notifications = e.data
            context.dispatch("setDashboardNotifications", notifications)
            context.dispatch(
                "setNotifications",
                _.orderBy(
                    _.toArray(_.orderBy(_.groupBy(notifications, "application.id"), ["created_at"], ["desc"])),
                    ["0.created_at", "created_at"],
                    ["desc", "desc"]
                )
            )
            context.dispatch("setTotalCount")
            if (!context.state.listener) {
                context.dispatch("startSocketListener")
            }
        })
    },
    clearAll(context) {
        Ambition.Request.call({
            url: "/api/notifications/clear-all",
            method: "POST"
        }).then(e => {
            context.dispatch("fetchNotitications")
            context.dispatch("setTotalCount")
            context.dispatch("setNewNotificationStatus", false)
        })
    },

    deleteNotification({dispatch, state}, payload) {
        let data = _.reduce(
            _.get(state, `notifications.${payload.index}`),
            (result, value) => {
                if (_.isArray(result)) {
                    result.push(value.id)
                } else {
                    result = []
                    result.push(value.id)
                }
                return result
            },
            {}
        )

        _.remove(state.notifications, (item, i) => {
            return i == payload.index
        })

        Ambition.Request.call({
            url: `/api/notifications/delete-multiple`,
            method: "POST",
            data
        }).then(e => {
            dispatch("fetchNotitications")
            dispatch("setTotalCount")
            dispatch("setNewNotificationStatus", false)
        })
    },

    clearNotifications(context) {
        context.commit("setNotifications", [])
    },

    startSocketListener({dispatch, commit, state}) {
        const tenant = Ambition.getGlobal("tenant.tenantName")
        const userId = Ambition.getGlobal("tenant.user.id")

        const eventHandler = response => {
            commit("setListener", true)
            dispatch("fetchNotitications")
            commit("setNewNotificationStatus", true)
            if (response.notification.type == "new-lead") {
                opportunityToasty(response.notification)
            }
        }

        Echo.private(`notifications.${tenant}.${userId}`).listen(".sent", eventHandler)
    },

    setNotifications({commit, dispatch}, data) {
        commit("setNotifications", data)
    },

    setDashboardNotifications({commit, dispatch}, data) {
        commit("setDashboardNotifications", data)
    },

    setTotalCount({commit, state, dispatch}) {
        let totalCount = _.reduce(
            state.notifications,
            (result, value) => {
                return _.size(value) + result
            },
            0
        )

        console.log('totalCount ', totalCount)

        commit("setTotalCount", totalCount)
        dispatch("global commit", {type: "notifications/setTotalCount", payload: totalCount}, {root: true})
    },

    setNewNotificationStatus({commit, dispatch}, status) {
        commit("setNewNotificationStatus", status)
        dispatch("global commit", {type: "notifications/setNewNotificationStatus", payload: status}, {root: true})
    }
}

function formatCurrency(amount, decimals = 0) {
    let currencyFormatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    })
    return currencyFormatter.format(amount)
}

function opportunityToasty(msg) {
    let message
    if (_.has(msg, "applicant.full_name")) {
        message = `<table>
                        <tbody>
                            <tr><th>Name:</th><td>${msg.applicant.full_name}</td></tr>
                            <tr><th>Value:</th><td>${formatCurrency(msg.application.amount)}</td></tr>
                            <tr><th>Email:</th><td>${msg.applicant.email}</td></tr>
                        </tbody>
                    </table>`
    } else {
        message = `<p>${msg.message}</p>`
    }

    Notification.info({
        title: `${msg.title}`,
        dangerouslyUseHTMLString: true,
        message: message,
        duration: 4500,
        onClick: () => {
            window.open("/admin/lead-management")
        },
        position: "bottom-left"
    })
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
